import React from "react";
import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { create } from "jss";
import { ThemeProvider } from "styled-components/macro";

import { StyledEngineProvider } from "@mui/styled-engine-sc";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import StylesProvider from "@mui/styles/StylesProvider";
import jssPreset from "@mui/styles/jssPreset";

import "./i18n";
import createTheme from "./theme";
import routes from "./routes";

import useTheme from "./hooks/useTheme";
import { store } from "./redux/store";

import { LendicaProvider } from "./contexts/LendicaContext";
import { AuthProvider } from "./contexts/JWTContext";
// import { AuthProvider } from "./contexts/FirebaseAuthContext";
// import { AuthProvider } from "./contexts/Auth0Context";
// import { AuthProvider } from "./contexts/CognitoContext";

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point"),
});

function App() {
  const content = useRoutes(routes);

  const { theme } = useTheme();

  // const [lendicaCredentials, setLendicaCredentials] = React.useState({
  //   partner_name: "apexdemo",
  //   company_id: "923857",
  //   company_name: "AAA Company",
  //   company_access_token: "20|OR72aFdNa9rz4s144o4yIppdjgxyVvumFxAEzHaW",
  // });
  // const [lendicaConfig, setLendicaConfig] = React.useState({
  //   access_type: "ADMIN", // "VIEW_ONLY" or "ADMIN"
  //   environment: "SANDBOX", // "SANDBOX" or "PRODUCTION"
  // });

  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="Lendica Demo"
        defaultTitle="Lendica iBranch Demo"
      />
      <Provider store={store}>
        <StylesProvider jss={jss}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StyledEngineProvider injectFirst>
              <MuiThemeProvider theme={createTheme(theme)}>
                <ThemeProvider theme={createTheme(theme)}>
                  <LendicaProvider>
                    <AuthProvider>{content}</AuthProvider>
                  </LendicaProvider>
                </ThemeProvider>
              </MuiThemeProvider>
            </StyledEngineProvider>
          </LocalizationProvider>
        </StylesProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
